<script>
export default {
  props: {
    message: { type: String, default: '' },
    action: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      toggleAfterTimeout: false,
    };
  },
  mounted() {},
  methods: {
    handleActionClick() {
      if (this.action?.type === 'link' && this.action?.to) {
        this.$router.push(this.action.to);
      }
    },
  },
};
</script>

<template>
  <div>
    <div
      class="shadow-sm bg-n-slate-12 dark:bg-n-slate-7 rounded-lg items-center gap-3 inline-flex mb-2 max-w-[25rem] min-h-[1.875rem] min-w-[15rem] px-6 py-3 text-left"
    >
      <div class="text-sm font-medium text-white dark:text-white">
        {{ message }}
      </div>
      <div v-if="action">
        <button
          v-if="action.type == 'link'"
          type="button"
          class="font-medium cursor-pointer select-none text-n-blue-10 hover:text-n-brand"
          @click="handleActionClick"
        >
          {{ action.message }}
        </button>
      </div>
    </div>
  </div>
</template>
